import router from '@/router/index';
import PermissionVerifier from '@/utils/PermissionVerifier';

Storage.prototype.setObj = function (key, obj) {
    return this.setItem(key, JSON.stringify(obj));
};
Storage.prototype.getObj = function (key) {
    return JSON.parse(this.getItem(key));
};
export default {
    namespaced: true,
    state: {
        permissions: localStorage.getObj('permissions') || [],
        user: localStorage.getObj('user'),
        roles: localStorage.getObj('roles')
    },
    getters: {
        getPermissions: (state) => state.permissions,
        getUser: (state) => state.user,
        getUserFullName (state) {
            if (state.user) {
                return state.user.full_name;
            }
            return '';
        },
        getRoles: (state) => state.roles
    },
    mutations: {
        setPermissions (state, payload) {
            state.permissions = payload;
        },
        setUser (state, payload) {
            state.user = payload;
        },
        setRoles (state, payload) {
            state.roles = payload;
        },
        noAccessAction () {
            router.push({ name: 'home' });
        }
    },
    actions: {
        setAuthData (context, data) {
            localStorage.setObj('permissions', data.data.permissions);
            localStorage.setObj('user', data.data.user);
            localStorage.setObj('roles', data.data.roles);
            context.commit('setPermissions', data.data.permissions);
            context.commit('setUser', data.data.user);
            context.commit('setRoles', data.data.roles);
        },
        permissionGuard (context, data, requireOneOfProvided = true) {
            const permissions = context.getters.getPermissions;
            let isAllowed = false;

            if (Array.isArray(data) === true) {
                isAllowed = PermissionVerifier.hasPermissions(permissions, data, requireOneOfProvided);
            } else {
                isAllowed = PermissionVerifier.hasPermission(permissions, data);
            }

            if (isAllowed === false) {
                context.commit('noAccessAction');
            }
        },
        hasPermission ({ getters }, data) {
            return PermissionVerifier.hasPermission(getters.getPermissions, data);
        }
    }
};
